import { render, staticRenderFns } from "./OrderFooter.vue?vue&type=template&id=cc36b07e&scoped=true&"
import script from "./OrderFooter.vue?vue&type=script&lang=js&"
export * from "./OrderFooter.vue?vue&type=script&lang=js&"
import style0 from "./OrderFooter.vue?vue&type=style&index=0&id=cc36b07e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc36b07e",
  null
  
)

export default component.exports